import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import PlaybookSectionView from "@/components/partner-hub/PlaybookSectionView";
import { publicPreviewSections, PLAYBOOK_VERSION } from "@/data/partnerPlaybook";

export default function PartnerPlaybookPublic() {
  const sections = publicPreviewSections();
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Partner & Advocate Playbook — The Emerging Market</title>
        <meta name="description" content="A preview of the field guide our Alabama partners and advocates use — code of conduct, brand voice, referral scripts, and more." />
        <link rel="canonical" href="https://emrkt.co/partners/playbook" />
        <meta property="og:title" content="Partner & Advocate Playbook — The Emerging Market" />
        <meta property="og:description" content="A preview of the field guide our Alabama partners and advocates use." />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <SiteHeader />

      <main className="pt-28 pb-20">
        {/* Hero */}
        <section className="px-4 sm:px-6 max-w-5xl mx-auto text-center">
          <Badge variant="outline" className="mb-4">Public preview · v{PLAYBOOK_VERSION}</Badge>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">
            Partner &amp; Advocate Playbook
          </h1>
          <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">
            The operating field guide our Alabama partners and advocates use every day — how we work, how we talk about the work, and how we keep it in service of the community.
          </p>
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <Button asChild size="lg">
              <Link to="/partners/apply">Apply to the program</Link>
            </Button>
            <Button asChild variant="outline" size="lg">
              <a href="/handbook/emrkt-partner-field-guide.pdf" target="_blank" rel="noreferrer">Download field guide (PDF)</a>
            </Button>
            <Button asChild variant="ghost" size="lg">
              <Link to="/partners/handbook">Full handbook (partners only)</Link>
            </Button>
          </div>
        </section>

        {/* Preview sections */}
        <section className="mt-16 px-4 sm:px-6 max-w-3xl mx-auto space-y-12">
          {sections.map((s) => (
            <PlaybookSectionView key={s.id} section={s} />
          ))}
        </section>

        {/* CTA */}
        <section className="mt-20 px-4 sm:px-6 max-w-3xl mx-auto">
          <div className="rounded-lg border border-border bg-card p-8 text-center">
            <h2 className="font-display text-2xl font-semibold">Want the rest?</h2>
            <p className="text-muted-foreground mt-2">
              Response SLAs, scoping guardrails, pricing bands, outcomes storytelling, and the full FAQ are inside the partner portal.
            </p>
            <div className="mt-5 flex flex-wrap gap-3 justify-center">
              <Button asChild>
                <Link to="/partners/apply">Apply</Link>
              </Button>
              <Button asChild variant="outline">
                <Link to="/partners">Program overview</Link>
              </Button>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}